
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormTextarea from "Common/Custom/FormTextarea";
import PropTypes from "prop-types";
import FormInputFile from "Common/Custom/FormInputFile";

const AddFoodForm = ({
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  FoodTypesOptions = [],
  fields = {},
  handleFileChange = () => { },
  imagePreview = "",
}) => {

  const optionConfig = {
    food_type_id: {
      list: FoodTypesOptions,
      valueKey: "food_type_id",
      labelKey: "food_type_name"
    }
  };

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={
      <HeadingOne>Create Food Item</HeadingOne>
    }>
      {fields?.map((field) => {

        if (field.type === "select") {
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={getSelectOptions(field.name, optionConfig)}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "textarea") {
          return (
            <FormTextarea
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }
        
        if (field.type === "file") {
          return (
              <FormInputFile
                  key={field.name}
                  field={field}
                  handleChange={handleFileChange}
                  error={errors[field.name]}
                  imagePreview={imagePreview}
              />
          );
      }

        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );

      })}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddFoodForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  FoodTypesOptions: PropTypes.array,
  handleFileChange: PropTypes.func,
  imagePreview: PropTypes.string,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  )
};

AddFoodForm.defaultProps = {
  values: {},
  errors: {},
  handleChange: () => { },
  handleSubmit: () => { },
  loading: false,
  FoodTypesOptions: [],
  fields: [],
  handleFileChange: () => { },
  imagePreview: "",
};

export default AddFoodForm;
